import expressionEvaluator from "./customExpression";

/**
 * Takes UI-State (redux-state) and converts to UI-Query
 * @param {Object} state
 */
const queryModelTransformer = state => {
	const { baseTable, organizationID, queryModel } = state;
	const uiQuery = queryModel.stagesModel.map(query => {
		return {
			stage: query["stage-name"],
			query: query.fields.reduce((result, value) => {
				if (value["is-repeatable"]) {
					result[value["field-name"]] = value.children.reduce((setResult, setValue) => {
						const setReturnValue = setValue.reduce((childrenResult, childrenValue) => {
							if (childrenValue["input-type"] === "expression-evaluator") {
								childrenResult[childrenValue["field-name"]] = expressionEvaluator(
									childrenValue.value,
									childrenValue.expressionType
								);
							} else {
								childrenResult[childrenValue["field-name"]] = childrenValue.value;
							}
							return childrenResult;
						}, {});
						setResult = [...setResult, setReturnValue];
						return setResult;
					}, []);
				} else if (value["is-expression"]) {
					result["filterExp"] = {
						operator: value.value,
						value: value.expression
					};
				} else if (value["input-type"] === "expression-evaluator") {
					result[value["field-name"]] = expressionEvaluator(value.value, value.expressionType);
				} else {
					result[value["field-name"]] = value.value;
				}
				return result;
			}, {})
		};
	});
	return uiQuery;
};

export default queryModelTransformer;
